/**
 * 订单流速：一次拉取过去 24 小时与 7 天两组图表
 */
import { useState, useCallback, useEffect } from 'react';
import { getOrderTrafficFromProxy, } from '../../service/storeRevenueApi';
export function pickOrderTrafficChart(bundle, range) {
    if (!bundle)
        return undefined;
    if (range === '24h')
        return bundle.last24Hours;
    return bundle.last7Days;
}
var emptyChart = {
    categories: [],
    dataset: {
        channel1Orders: [],
        channel2Orders: [],
        channel3Orders: [],
        channel4Orders: [],
        averagePrice: [],
    },
    axes: {
        left: { id: 'left', position: 'left', name: '订单量', unit: '单', max: 100 },
        right: { id: 'right', position: 'right', name: '平均价格', unit: '元', min: 0, max: 1000 },
    },
    series: [],
    comparison: { yearOverYear: 0, weekOverWeek: 0 },
};
var emptyBundle = {
    last24Hours: emptyChart,
    last7Days: emptyChart,
};
export function useOrderTrafficData(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(emptyBundle), data = _a[0], setData = _a[1];
    var _b = useState(function () { return enabled; }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () { return setRefreshKey(function (k) { return k + 1; }); }, []);
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setData(emptyBundle);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getOrderTrafficFromProxy(storeId)
            .then(function (res) {
            if (cancelled)
                return;
            setData(res !== null && res !== void 0 ? res : emptyBundle);
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(emptyBundle);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, enabled, refreshKey]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
